import React from 'react'

const hanoi = {
    id: 'hanoi-highlights',
    type: 'photoPost',
    countryId: 'seAsia',
    title: 'Hanoi Highlights in Photos',
    month: 'Oct',
    date: '18',
    content: [
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/PeterHanoi-2.jpg',
            detailText: (
                <div>While the best thing we did in Hanoi was <a href="/post/hanoi-street-food/">eat everything in sight</a>, we also explored the city over the 10 days we spent there. On our first full day in Hanoi, Peter fell in love with the pho xao in our alley (though this picture is with my fried rice, before his food came out.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/meat.jpg',
            detailText: 'The alleys behind Ngọc Hà have vendors in many doorways, with motorbikes rushing through the small streets.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/temple.jpg',
            detailText: 'Đình Ngọc Hà, the temple down the street from our apartment and next to our favorite pho spot. We walked past it frequently going to buy food from the alley vendors.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/cooking.jpg',
            detailText: 'On our second night, we took a cooking class offered by a university student in her apartment. Peter is frying up eggs to cut into strips for spring rolls, which also had carrot, cucumber, mint, cilantro, green banana, pork, and pork pate.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/crowd.jpg',
            detailText: "From Friday through Sunday night, the streets encircling Hoan Kiem lake in the Old Quarter are closed to vehicles and bikes. Families, couples, friends, tourists, and joggers wander freely, and it's always super busy. You can spend a great hour walking around the lake and people watching."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/palace.jpg',
            detailText: 'Ho Chi Minh built this Stilt House on the presidential palace grounds, feeling that the French colonial mansion next to it was too grand for a man striving to live simply as the Vietnamese people did.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/mausoleum.jpg',
            detailText: "Ho Chi Minh's body is embalmed in a mausoleum, despite the fact that he wanted it to be cremated and one third of the ashes spread in north, the south, and central Vietnam.I got in line at 6: 50 a.m. (when jetlag meant this was normal morning timing) and jostled with Chinese and Vietnamese tourists cramming in a line to get in.He's much better lit than Lenin was in Moscow, but like Lenin, you have to walk in a circle around the tomb without stopping while being watched by armed guards. Also, the Hanoi air was polluted most of the time we were there, and we only got hazy sunsets like this."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/train2.jpg',
            detailText: "A few times a day in the morning and evening, a high speed train rushes just feet from the doors of Hanoi citizens. The trainline has been in place for over a hundred years and the people there are used to hanging out on the tracks until moments before it goes by, though the city says they can't keep tables and chairs out anymore."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/PeterTrain.jpg',
            detailText: 'One night, we went to a bar that overlooks the train to see it speed by around 7. A Finnish couple was also there to watch (and made us want to visit Finland!), and several tourists sat by the tracks. After the first train most people left and we stayed; the bar staff were utterly unfazed by the remaining trains and sat smoking two feet from the tracks.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/lake2.jpg',
            detailText: "Hanoi is a charming and beautiful city. It's crazy busy in the Old Quarter and around Hoan Kiem lake, but walk out of the main area along Trúc Bạch Lake or West Lake and it's gorgeous and peaceful in the right weather. There are also trees and plants everywhere."
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/AliceCoffee.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/tourists.jpg'],
            detailText: "Alice with her new favorite drink, coconut coffee, at Cafe Pho Co (beautiful view of the Old Quarter), though Cong Ca Phe in Ba Dinh is where we actually bought this nearly every day. And us as extreme tourists before our death-defying bike tour from St. Joseph's Cathedral across Long Bien bridge and back (at RUSH HOUR.)"
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/Hanoi/PagodaSunset.jpg',
            detailText: 'Sunset behind the Tran Quoc Pagoda.'
        },
    ]
}


export default hanoi


// WEBPACK FOOTER //
// ./src/Posts/Content/Hanoi.js